// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { ProcedureResource_abstract } from './../abstract/SagaSchema/ProcedureResource_abstract';
export class ProcedureResource extends ProcedureResource_abstract {}
